/* @flow */

import React, { Fragment } from 'react'
import { TelInput } from 'atpjs/components/form/input'
import i18n from 'atpjs/helpers/i18n'
import Step from 'tve/views/step'
import Application from 'tve/components/application'

const t = i18n.prefix(['otp'])

class Otp extends Step {
  sendData = false

  verify = () => {
    const { verifyOtp } = this.props
    const pin = this.getModal(['pin'])
    verifyOtp(pin)
  }

  send = () => {
    const { sendOtp, id } = this.props
    sendOtp(id).then(() => {
      this.setState({ send: true })
    })
  }

  onSubmit = (event) => {
    event.preventDefault()
    this.verify()
  }

  render() {
    const { otpData } = this.props
    const { send } = this.state
    const inputSetProps = this.inputSetProps('modal')

    return (
      <Application title={t(['title'])} name={i18n.trans(['tve', 'title'])}>
        <form onSubmit={this.onSubmit}>
          {send ? (
            <Fragment>
              <p className="atp-margin-bottom-s">
                {i18n.transTag(['otp', 'weHaveSent'], { number: otpData.number })}
                <br />
                {t('pleaseEnterTheCode')}
              </p>
              <div className="atp-grid">
                <div className="atp-grid-2-1 atp-grid-s-1-1">
                  <TelInput
                    {...inputSetProps(['pin'])}
                    wrapperClassName="atp-padding-bottom-xs atp-padding-bottom-s-s"
                  />
                </div>
              </div>
              <div className="atp-buttons atp-margin-bottom-s">
                <button
                  type="button"
                  className="atp-btn atp-btn--align-with-label atp-btn--primary atp-btn--right-icon atp-btn--icon-arrow-right atp-float--left atp-align-to-input"
                  onClick={this.verify}>
                  {t('verify')}
                </button>
              </div>
              {otpData && (
                <ul className="atp-messages">
                  {otpData.status == 'failed' && (
                    <li className="atp-messages__entry atp-messages__entry--error">
                      <p className="atp-messages__title">
                        Es ist ein Fehler bei der Verifizierung aufgetreten. Probieren Sie es nochmals oder fordern
                        einen neuen Code an.
                      </p>
                    </li>
                  )}
                  {otpData.status == 'tooManyRequests' && (
                    <li className="atp-messages__entry atp-messages__entry--error">
                      <p className="atp-messages__title">
                        Probieren Sie es in 5 Minuten noch einmal, Sie sind momentan gesperrt wegen zu vielen versuchen.
                      </p>
                    </li>
                  )}
                </ul>
              )}
              <button type="button" className="atp-btn" onClick={this.send}>
                {t('resend')}
              </button>
            </Fragment>
          ) : (
            <Fragment>
              <p className="atp-margin-bottom-s">{i18n.transTag(['otp', 'disclaimer'])}</p>
              <div className="atp-buttons atp-padding-top-no">
                <button
                  type="button"
                  className="atp-btn atp-btn--primary atp-btn--right-icon atp-btn--icon-arrow-right atp-float--left"
                  onClick={this.send}>
                  {t('send')}
                </button>
              </div>
            </Fragment>
          )}
        </form>
      </Application>
    )
  }
}

export default Otp
